export default [
  {
    path: 'inventory',
    name: 'website.inventory',
    component: () => import('@/views/website/inventory'),
  },
];
